import React from "react";
import { Link } from "react-router-dom";

export default class TeamGallery extends React.Component {
  render() {
    return (
      <div>
        <div className="container-fluid">
          <div className="form-head d-flex flex-wrap align-items-center">
            <div className="me-auto">
              <h2 className="font-w600 mb-0">Employee Album</h2>
              <p className="text-light">Lorem ipsum dolor sit amet </p>
            </div>
            <div className="d-flex me-3">
              <div className="form-check me-2">
                <input
                  className="form-check-input"
                  type="radio"
                  name="gridRadios"
                  value="option1"
                  checked=""
                />
                <label className="form-check-label">By Event</label>
              </div>
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="radio"
                  name="gridRadios"
                  value="option1"
                  checked=""
                />
                <label className="form-check-label">By Emplyoee</label>
              </div>
            </div>
            <button
              className="add-btncss mb-2"
              data-bs-toggle="modal"
              data-bs-target="#add-album"
            >
              <i aria-hidden="true" className="fa fa-plus me-2"></i>Create New
              Album
            </button>
          </div>
          <div className="row">
            <div className="col-xl-12">
              <div className="row">
                <div className="col-xl-2 py-4">
                  <div
                    className="media-feed-item has-background-image"
                    style={{ backgroundImage: "url(images/gallery/1.jpg)" }}
                  >
                    <span className="tag item-duration">0 pics</span>
                    <Link to="SingleGallery" className="play-button">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-arrow-right-circle"
                        viewBox="0 0 16 16"
                      >
                        <path
                          fillRule="evenodd"
                          d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z"
                        />
                      </svg>
                    </Link>
                    <div className="item-overlay"></div>
                    <div className="overlay-layer">
                      <div className="overlay-content">
                        <div className="inner-content">
                          <h3 className="media-title team-h3">
                            <div className="h-avatar team-avatar">
                              <img
                                className="avatar"
                                src="images/avatar/1.jpg"
                                data-demo-src="images/avatar/1.jpg"
                                alt=""
                                data-user-popover="25"
                                data-target="webuiPopover6"
                              />
                            </div>
                            Employee name
                          </h3>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-2 py-4">
                  <div
                    className="media-feed-item has-background-image"
                    style={{ backgroundImage: "url(images/gallery/2.jpg)" }}
                  >
                    <span className="tag item-duration">0 pics</span>
                    <Link to="SingleGallery" className="play-button">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-arrow-right-circle"
                        viewBox="0 0 16 16"
                      >
                        <path
                          fillRule="evenodd"
                          d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z"
                        />
                      </svg>
                    </Link>
                    <div className="item-overlay"></div>
                    <div className="overlay-layer">
                      <div className="overlay-content">
                        <div className="inner-content">
                          <h3 className="media-title team-h3">
                            <div className="h-avatar team-avatar">
                              <img
                                className="avatar"
                                src="images/avatar/1.jpg"
                                data-demo-src="images/avatar/1.jpg"
                                alt=""
                                data-user-popover="25"
                                data-target="webuiPopover6"
                              />
                            </div>
                            Employee name
                          </h3>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-2 py-4">
                  <div
                    className="media-feed-item has-background-image"
                    style={{ backgroundImage: "url(images/gallery/3.jpg)" }}
                  >
                    <span className="tag item-duration">10 pics</span>
                    <Link to="SingleGallery" className="play-button">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-arrow-right-circle"
                        viewBox="0 0 16 16"
                      >
                        <path
                          fillRule="evenodd"
                          d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z"
                        />
                      </svg>
                    </Link>
                    <div className="item-overlay"></div>
                    <div className="overlay-layer">
                      <div className="overlay-content">
                        <div className="inner-content">
                          <h3 className="media-title team-h3">
                            <div className="h-avatar team-avatar">
                              <img
                                className="avatar"
                                src="images/avatar/1.jpg"
                                data-demo-src="images/avatar/1.jpg"
                                alt=""
                                data-user-popover="25"
                                data-target="webuiPopover6"
                              />
                            </div>
                            Employee name
                          </h3>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-2 py-4">
                  <div
                    className="media-feed-item has-background-image"
                    style={{ backgroundImage: "url(images/gallery/4.jpg)" }}
                  >
                    {/* <!--Play button--> */}
                    <span className="tag item-duration">10 pics</span>
                    <Link to="SingleGallery" className="play-button">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-arrow-right-circle"
                        viewBox="0 0 16 16"
                      >
                        <path
                          fillRule="evenodd"
                          d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z"
                        />
                      </svg>
                    </Link>
                    <div className="item-overlay"></div>
                    <div className="overlay-layer">
                      <div className="overlay-content">
                        <div className="inner-content">
                          <h3 className="media-title team-h3">
                            <div className="h-avatar team-avatar">
                              <img
                                className="avatar"
                                src="images/avatar/1.jpg"
                                data-demo-src="images/avatar/1.jpg"
                                alt=""
                                data-user-popover="25"
                                data-target="webuiPopover6"
                              />
                            </div>
                            Employee name
                          </h3>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-2 py-4">
                  <div
                    className="media-feed-item has-background-image"
                    style={{ backgroundImage: "url(images/gallery/3.jpg)" }}
                  >
                    <span className="tag item-duration">10 pics</span>
                    <Link to="SingleGallery" className="play-button">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-arrow-right-circle"
                        viewBox="0 0 16 16"
                      >
                        <path
                          fillRule="evenodd"
                          d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z"
                        />
                      </svg>
                    </Link>
                    <div className="item-overlay"></div>
                    <div className="overlay-layer">
                      <div className="overlay-content">
                        <div className="inner-content">
                          <h3 className="media-title team-h3">
                            <div className="h-avatar team-avatar">
                              <img
                                className="avatar"
                                src="images/avatar/1.jpg"
                                data-demo-src="images/avatar/1.jpg"
                                alt=""
                                data-user-popover="25"
                                data-target="webuiPopover6"
                              />
                            </div>
                            Employee name
                          </h3>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-2 py-4">
                  <div
                    className="media-feed-item has-background-image"
                    style={{ backgroundImage: "url(images/gallery/4.jpg)" }}
                  >
                    <span className="tag item-duration">10 pics</span>
                    <Link to="SingleGallery" className="play-button">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-arrow-right-circle"
                        viewBox="0 0 16 16"
                      >
                        <path
                          fillRule="evenodd"
                          d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z"
                        />
                      </svg>
                    </Link>
                    <div className="item-overlay"></div>
                    <div className="overlay-layer">
                      <div className="overlay-content">
                        <div className="inner-content">
                          <h3 className="media-title team-h3">
                            <div className="h-avatar team-avatar">
                              <img
                                className="avatar"
                                src="images/avatar/1.jpg"
                                data-demo-src="images/avatar/1.jpg"
                                alt=""
                                data-user-popover="25"
                                data-target="webuiPopover6"
                              />
                            </div>
                            Employee name
                          </h3>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-xl-12">
              <div className="row">
                <div className="col-xl-2 py-4">
                  <div
                    className="media-feed-item has-background-image"
                    style={{ backgroundImage: "url(images/gallery/2.jpg)" }}
                  >
                    <span className="tag item-duration">10 pics</span>
                    <button className="play-button">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-arrow-right-circle"
                        viewBox="0 0 16 16"
                      >
                        <path
                          fillRule="evenodd"
                          d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z"
                        />
                      </svg>
                    </button>
                    <div className="item-overlay"></div>
                    <div className="overlay-layer">
                      <div className="overlay-content">
                        <div className="inner-content">
                          <h3 className="media-title team-h3">
                            <div className="h-avatar team-avatar">
                              <img
                                className="avatar"
                                src="images/avatar/1.jpg"
                                data-demo-src="images/avatar/1.jpg"
                                alt=""
                                data-user-popover="25"
                                data-target="webuiPopover6"
                              />
                            </div>
                            Employee name
                          </h3>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-2 py-4">
                  <div
                    className="media-feed-item has-background-image"
                    style={{ backgroundImage: "url(images/gallery/2.jpg)" }}
                  >
                    <span className="tag item-duration">10 pics</span>
                    <button className="play-button">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-arrow-right-circle"
                        viewBox="0 0 16 16"
                      >
                        <path
                          fillRule="evenodd"
                          d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z"
                        />
                      </svg>
                    </button>
                    <div className="item-overlay"></div>
                    <div className="overlay-layer">
                      <div className="overlay-content">
                        <div className="inner-content">
                          <h3 className="media-title team-h3">
                            <div className="h-avatar team-avatar">
                              <img
                                className="avatar"
                                src="images/avatar/1.jpg"
                                data-demo-src="images/avatar/1.jpg"
                                alt=""
                                data-user-popover="25"
                                data-target="webuiPopover6"
                              />
                            </div>
                            Employee name
                          </h3>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-2 py-4">
                  <div
                    className="media-feed-item has-background-image"
                    style={{ backgroundImage: "url(images/gallery/2.jpg)" }}
                  >
                    <span className="tag item-duration">10 pics</span>
                    <button className="play-button">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-arrow-right-circle"
                        viewBox="0 0 16 16"
                      >
                        <path
                          fillRule="evenodd"
                          d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z"
                        />
                      </svg>
                    </button>
                    <div className="item-overlay"></div>
                    <div className="overlay-layer">
                      <div className="overlay-content">
                        <div className="inner-content">
                          <h3 className="media-title team-h3">
                            <div className="h-avatar team-avatar">
                              <img
                                className="avatar"
                                src="images/avatar/1.jpg"
                                data-demo-src="images/avatar/1.jpg"
                                alt=""
                                data-user-popover="25"
                                data-target="webuiPopover6"
                              />
                            </div>
                            Employee name
                          </h3>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-2 py-4">
                  <div
                    className="media-feed-item has-background-image"
                    style={{ backgroundImage: "url(images/gallery/3.jpg)" }}
                  >
                    <span className="tag item-duration">10 pics</span>
                    <button className="play-button">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-arrow-right-circle"
                        viewBox="0 0 16 16"
                      >
                        <path
                          fillRule="evenodd"
                          d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z"
                        />
                      </svg>
                    </button>
                    <div className="item-overlay"></div>
                    <div className="overlay-layer">
                      <div className="overlay-content">
                        <div className="inner-content">
                          <h3 className="media-title team-h3">
                            <div className="h-avatar team-avatar">
                              <img
                                className="avatar"
                                src="images/avatar/1.jpg"
                                data-demo-src="images/avatar/1.jpg"
                                alt=""
                                data-user-popover="25"
                                data-target="webuiPopover6"
                              />
                            </div>
                            Employee name
                          </h3>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-2 py-4">
                  <div
                    className="media-feed-item has-background-image"
                    style={{ backgroundImage: "url(images/gallery/2.jpg)" }}
                  >
                    <span className="tag item-duration">10 pics</span>
                    <button className="play-button">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-arrow-right-circle"
                        viewBox="0 0 16 16"
                      >
                        <path
                          fillRule="evenodd"
                          d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z"
                        />
                      </svg>
                    </button>
                    <div className="item-overlay"></div>
                    <div className="overlay-layer">
                      <div className="overlay-content">
                        <div className="inner-content">
                          <h3 className="media-title team-h3">
                            <div className="h-avatar team-avatar">
                              <img
                                className="avatar"
                                src="images/avatar/1.jpg"
                                data-demo-src="images/avatar/1.jpg"
                                alt=""
                                data-user-popover="25"
                                data-target="webuiPopover6"
                              />
                            </div>
                            Employee name
                          </h3>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-2 py-4">
                  <div
                    className="media-feed-item has-background-image"
                    style={{ backgroundImage: "url(images/gallery/2.jpg)" }}
                  >
                    <span className="tag item-duration">10 pics</span>
                    <button className="play-button">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-arrow-right-circle"
                        viewBox="0 0 16 16"
                      >
                        <path
                          fillRule="evenodd"
                          d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z"
                        />
                      </svg>
                    </button>
                    <div className="item-overlay"></div>
                    <div className="overlay-layer">
                      <div className="overlay-content">
                        <div className="inner-content">
                          <h3 className="media-title team-h3">
                            <div className="h-avatar team-avatar">
                              <img
                                className="avatar"
                                src="images/avatar/1.jpg"
                                data-demo-src="images/avatar/1.jpg"
                                alt=""
                                data-user-popover="25"
                                data-target="webuiPopover6"
                              />
                            </div>
                            Employee name
                          </h3>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-2 py-4">
                  <div
                    className="media-feed-item has-background-image"
                    style={{ backgroundImage: "url(images/gallery/2.jpg)" }}
                  >
                    <span className="tag item-duration">10 pics</span>
                    <button className="play-button">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-arrow-right-circle"
                        viewBox="0 0 16 16"
                      >
                        <path
                          fillRule="evenodd"
                          d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z"
                        />
                      </svg>
                    </button>
                    <div className="item-overlay"></div>
                    <div className="overlay-layer">
                      <div className="overlay-content">
                        <div className="inner-content">
                          <h3 className="media-title team-h3">
                            <div className="h-avatar team-avatar">
                              <img
                                className="avatar"
                                src="images/avatar/1.jpg"
                                data-demo-src="images/avatar/1.jpg"
                                alt=""
                                data-user-popover="25"
                                data-target="webuiPopover6"
                              />
                            </div>
                            Employee name
                          </h3>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-2 py-4">
                  <div
                    className="media-feed-item has-background-image"
                    style={{ backgroundImage: "url(images/gallery/2.jpg)" }}
                  >
                    <span className="tag item-duration">10 pics</span>
                    <button className="play-button">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-arrow-right-circle"
                        viewBox="0 0 16 16"
                      >
                        <path
                          fillRule="evenodd"
                          d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z"
                        />
                      </svg>
                    </button>
                    <div className="item-overlay"></div>
                    <div className="overlay-layer">
                      <div className="overlay-content">
                        <div className="inner-content">
                          <h3 className="media-title team-h3">
                            <div className="h-avatar team-avatar">
                              <img
                                className="avatar"
                                src="images/avatar/1.jpg"
                                data-demo-src="images/avatar/1.jpg"
                                alt=""
                                data-user-popover="25"
                                data-target="webuiPopover6"
                              />
                            </div>
                            Employee name
                          </h3>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-2 py-4">
                  <div
                    className="media-feed-item has-background-image"
                    style={{ backgroundImage: "url(images/gallery/2.jpg)" }}
                  >
                    <span className="tag item-duration">10 pics</span>
                    <button className="play-button">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-arrow-right-circle"
                        viewBox="0 0 16 16"
                      >
                        <path
                          fillRule="evenodd"
                          d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z"
                        />
                      </svg>
                    </button>
                    <div className="item-overlay"></div>
                    <div className="overlay-layer">
                      <div className="overlay-content">
                        <div className="inner-content">
                          <h3 className="media-title team-h3">
                            <div className="h-avatar team-avatar">
                              <img
                                className="avatar"
                                src="images/avatar/1.jpg"
                                data-demo-src="images/avatar/1.jpg"
                                alt=""
                                data-user-popover="25"
                                data-target="webuiPopover6"
                              />
                            </div>
                            Employee name
                          </h3>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-2 py-4">
                  <div
                    className="media-feed-item has-background-image"
                    style={{ backgroundImage: "url(images/gallery/2.jpg)" }}
                  >
                    <span className="tag item-duration">10 pics</span>
                    <button className="play-button">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-arrow-right-circle"
                        viewBox="0 0 16 16"
                      >
                        <path
                          fillRule="evenodd"
                          d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z"
                        />
                      </svg>
                    </button>
                    <div className="item-overlay"></div>
                    <div className="overlay-layer">
                      <div className="overlay-content">
                        <div className="inner-content">
                          <h3 className="media-title team-h3">
                            <div className="h-avatar team-avatar">
                              <img
                                className="avatar"
                                src="images/avatar/1.jpg"
                                data-demo-src="images/avatar/1.jpg"
                                alt=""
                                data-user-popover="25"
                                data-target="webuiPopover6"
                              />
                            </div>
                            Employee name
                          </h3>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-2 py-4">
                  <div
                    className="media-feed-item has-background-image"
                    style={{ backgroundImage: "url(images/gallery/4.jpg)" }}
                  >
                    <span className="tag item-duration">10 pics</span>
                    <button className="play-button">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-arrow-right-circle"
                        viewBox="0 0 16 16"
                      >
                        <path
                          fillRule="evenodd"
                          d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z"
                        />
                      </svg>
                    </button>
                    <div className="item-overlay"></div>
                    <div className="overlay-layer">
                      <div className="overlay-content">
                        <div className="inner-content">
                          <h3 className="media-title team-h3">
                            <div className="h-avatar team-avatar">
                              <img
                                className="avatar"
                                src="images/avatar/1.jpg"
                                data-demo-src="images/avatar/1.jpg"
                                alt=""
                                data-user-popover="25"
                                data-target="webuiPopover6"
                              />
                            </div>
                            Employee name
                          </h3>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="modal fade" id="add-album">
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Create Album</h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                ></button>
              </div>
              <div className="modal-body">
                <label>Album Name</label>
                <textarea rows="2" cols="1" className="form-control"></textarea>
                <label className="mt-3">Album Description</label>
                <textarea rows="4" cols="1" className="form-control"></textarea>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-danger light"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
                <button type="button" className="btn btn-primary">
                  Save changes
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
